import React from "react";
import { Styled } from './styled';
import Quote from "~/components/quote";
import {SellMoreScreen} from "~common/sell-more-screen";

const Admin = () => {
  return (
    <>
      <Styled.Container>
        <Styled.Title>
          Приложение для администратора аккаунта
        </Styled.Title>
        <Styled.Text>
          <Styled.Text>Чтобы наши клиенты могли управлять телефонией всегда и везде, мы продублировали наш сервис в мобильное приложение. В приложении можно:</Styled.Text>
          <Styled.List>
            <Styled.TextList>просмотреть и прослушать звонки сотрудников;</Styled.TextList>
            <Styled.TextList>отфильтровать звонки по различным параметрам;</Styled.TextList>
            <Styled.TextList>проанализировать графики по каждому типу звонка;</Styled.TextList>
            <Styled.TextList>узнать средние значения: количество звонков, длительность звонка, оценка качества;</Styled.TextList>
            <Styled.TextList>связаться с технической поддержкой;</Styled.TextList>
            <Styled.TextList>изменить данные аккаунта;</Styled.TextList>
            <Styled.TextList>изменить некоторые настройки АТС (голосовое приветствие, номер, пользователь);</Styled.TextList>
          </Styled.List>
          <Styled.Text>Сейчас мы работаем над добавлением пуш-уведомлений и расширением управления настройками телефонии.</Styled.Text>
        </Styled.Text>
        <Styled.Block>
          <Styled.Image src={process.env.PUBLIC_DIR + '/images/features-page/calls-detail/adminapp-img.svg'} />
        </Styled.Block>
        <Styled.BlockQuote>
          <Quote width='800'>
            <Styled.TextBold>Ольга, владелица магазина детских товаров</Styled.TextBold>
            <Styled.Indent/>
            <Styled.TextComment>В офисе я почти не бываю, весь день катаюсь по поставщикам. Проверить звонки могу только в обеденный перерыв. С ноутбуком в поездках неудобно, я все делаю через телефон, в том числе проверяю звонки. Фильтрую по каждому сотруднику и смотрю графики, оценку качества, иногда слушаю разговоры.</Styled.TextComment>
            <Styled.Indent/>
            <Styled.TextComment>Пару раз бывало, что закрутилась и забыла оплатить телефонию, всё отключалось. Быстро заходила с телефона, оплачивала и через минуту всё снова работало, это спасает.</Styled.TextComment>
            <Styled.Indent/>
            <Styled.TextComment>Жду, когда появится возможность менять настройки в приложении, иногда нужно заменить приветствие или переадресацию поставить.</Styled.TextComment>
          </Quote>
        </Styled.BlockQuote>
      </Styled.Container>
      <Styled.SelMore className="onlinepbx__sel__more">
        <SellMoreScreen />
      </Styled.SelMore>
    </>
  )
}

export default Admin
